<div class="device-buttons">
  <mat-button-toggle-group class="small-mt-16" hideSingleSelectionIndicator="true">
    <div class="mat-button-toggle-wrapper">
      <mat-button-toggle
        [matTooltip]="(isNativeApp ? 'campaign.widget.device-tablet' : 'campaign.widget.device-desktop') | translate"
        [class.active]="currentDeviceView === DeviceViewEnums.Desktop"
        [disableRipple]="true"
        mat-stroked-button
        (click)="changeCurrentDeviceView(DeviceViewEnums.Desktop)">
        <mat-icon>{{ isNativeApp ? "tablet_mac" : "desktop_windows" }}</mat-icon>
        <span class="device-name desktop">
          {{ (isNativeApp ? "campaign.widget.device-tablet" : "campaign.widget.device-desktop") | translate | uppercase }}
        </span>
      </mat-button-toggle>
    </div>
    <div class="mat-button-toggle-wrapper">
      <mat-button-toggle
        [matTooltip]="'campaign.widget.device-mobile' | translate"
        [class.active]="currentDeviceView === DeviceViewEnums.Mobile"
        [disableRipple]="true"
        mat-stroked-button
        (click)="changeCurrentDeviceView(DeviceViewEnums.Mobile)">
        <mat-icon>phone_iphone</mat-icon>
        <span class="device-name mobile">{{ "campaign.widget.device-mobile" | translate | uppercase }}</span>
      </mat-button-toggle>
    </div>
  </mat-button-toggle-group>
</div>
